// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ViewEmployeeInformation_wrapper__3-TMk","informationSections":"ViewEmployeeInformation_informationSections__11SMz","close":"ViewEmployeeInformation_close__3MyTd"};